import Vue from 'vue'
import Router from 'vue-router'

import Activities from '@/pages/Activities'
import Analytics from '@/pages/Analytics'
import Callback from '@/pages/Callback'
import Help from '@/pages/Help'
import Privacy from '@/pages/Privacy'
import Products from '@/pages/Products'
import ShareLinkExpired from '@/pages/ShareLinkExpired'
import ShareLinkInvalid from '@/pages/ShareLinkInvalid'
import Shopify from '@/pages/Shopify'
import Terms from '@/pages/Terms'
import Welcome from '@/pages/Welcome'
import Settings from '@/pages/Settings'

import { requireAuth, login, logout } from '@/utils/auth.js'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  linkExactActiveClass: '',
  mode: 'history',
  routes: [
    {
      path: '*',
      name: '404',
      redirect: '/'
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome,
      beforeEnter: requireAuth
    },
    /*
     * 1. Disables the "Activites" view
     *    remove the redirect to re-enable
    */
    {
      path: '/activity',
      name: 'Activities',
      component: Activities,
      beforeEnter: requireAuth,
      redirect: '/' /* 1 */
    },
    /*
     * 1. Disables the "Activity Detail" view
     *    remove the redirect to re-enable
    */
    {
      path: '/activity/:id',
      name: 'Activity Detail',
      component: Activities,
      beforeEnter: requireAuth,
      redirect: '/' /* 1 */
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: Analytics,
      beforeEnter: requireAuth
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/expired',
      name: 'ShareLinkExpired',
      component: ShareLinkExpired
    },
    {
      path: '/invalid',
      name: 'ShareLinkInvalid',
      component: ShareLinkInvalid
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      beforeEnter: requireAuth
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      beforeEnter: requireAuth
    },
    {
      path: '/integrations/shopify',
      name: 'Shopify',
      component: Shopify
    },
    {
      path: '/login',
      name: 'Login',
      redirect: login
    },
    {
      path: '/logout',
      name: 'Logout',
      redirect: logout
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      beforeEnter: requireAuth
    },
    {
      path: '/',
      name: 'Products',
      component: Products,
      beforeEnter: requireAuth
    },
    {
      path: '/product/:productId',
      name: 'Product Detail',
      component: Products,
      beforeEnter: requireAuth
    },
    {
      path: '/collection/:id',
      name: 'Product Collection',
      component: Products,
      beforeEnter: requireAuth
    },
    {
      path: '/collection/:id/product/:productId',
      name: 'Product Collection Detail',
      component: Products,
      beforeEnter: requireAuth
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      beforeEnter: requireAuth
    }
  ]
})



// WEBPACK FOOTER //
// ./src/js/router/index.js